import { Policy } from "components/icons/generated";
import usePolicySearchForNavigation from "shared/Policy/useSearchForNavigation";

import CommandPaletteEntitySearch from "./EntitySearch";

const useSearchHook = ({ query }: { query: string }) => {
  return usePolicySearchForNavigation({ query });
};

const CommandPaletteSubListViewPoliciesSearch = () => (
  <CommandPaletteEntitySearch
    useSearchHook={useSearchHook}
    icon={Policy}
    pathPrefix="/policy/"
    entityName="policies"
  />
);

export default CommandPaletteSubListViewPoliciesSearch;
